import { useMemo } from "react";

import * as FormModel from "@/components/features/settings/payment-deposit-account/model";
import type * as FormModelType from "@/components/features/settings/payment-deposit-account/model/type";
import type * as QueryRepository from "@/components/features/settings/payment-deposit-account/repository/query";

import * as Converter from "./converter";

type Props = {
	serverModel: QueryRepository.ServerModel;
};

export const useInitialized = ({ serverModel }: Props) => {
	/**
	 * InitInputModel の生成
	 */
	const initInputModel: FormModelType.PaymentDepositAccountFormModel["InputModel"] = useMemo(
		() => Converter.serverModelToInputModelConverter(serverModel),
		[serverModel],
	);

	/**
	 * QueryData の生成
	 */
	const queryData: FormModelType.PaymentDepositAccountFormModel["QueryData"] = useMemo(
		() => serverModel,
		[serverModel],
	);

	const { viewModel, onSetViewModel, onResetViewModel } = FormModel.usePaymentCreditFormModel(initInputModel);

	return {
		queryData,
		viewModel,
		onSetViewModel,
		onResetViewModel,
	};
};
